export default "__VITE_ASSET__62ed0f2b__"